var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-head"},[_c('div',{staticClass:"line flex-between"},[_c('img',{staticClass:"logo",attrs:{"src":require("../../assets/img/mobile/logo.svg")}}),_c('m-nav')],1),(!_vm.isContact)?_c('m-search'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }